import React, { useState, useRef, useEffect } from "react";

import { Modal } from "pepsico-ds";


const NotificationPrompt = ({header, description, buttonText, action, setModal, data}) => {



    return <>
                <Modal
                
                    closeOnOutsideClick={false}
                    onCloseModal={function oFe(){setModal(false)}}
                    primaryButtonProps={{
                        onClick: ()=>{action(data);setModal(false);},
                        size: 'medium',
                        text: buttonText,
                        variant: 'primary'
                    }}
                    tertiaryButtonProps={{
                        onClick: ()=>{setModal(false)},
                        size: 'medium',
                        text: 'Cancel',
                        variant: 'tertiary'
                    }}
                    showModal={true}
                    showLink={false}
                    showPrimaryButton={true}
                    showSecondaryButton={false}
                    showTertiaryButton={true}
                    showAuxiliaryButton={false}
                    type="S"
                    title={header}
                    >
                        <div>
                            <div className="download-inprogress-text" style={{fontSize: 14, fontWeight: 400, color: "#2D2D2D"}}>{description}</div>
                        </div>
                </Modal>

            </>;

};

export default NotificationPrompt;